"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Icon_1 = __importStar(require("../Icon"));
var ProgressIndicator_1 = __importDefault(require("../ProgressIndicator"));
var notificationBar = function (props) {
    var items = props.items, onDismiss = props.onDismiss, className = props.className, errorBar = props.errorBar;
    if (items.length === 0) {
        return null;
    }
    var itemData = items.map(function (item) {
        var btn;
        if (item.closable) {
            btn = (react_1.default.createElement("div", { className: "item_close", onClick: onDismiss.bind(item, item.id) },
                react_1.default.createElement(Icon_1.default, { icon: Icon_1.IconType.Cross })));
            if (item.inProgress) {
                // tslint:disable-next-line:no-console
                console.warn("Notification item can be closable OR in progress not both!");
            }
        }
        else if (item.inProgress) {
            btn = react_1.default.createElement(ProgressIndicator_1.default, { small: true, overlay: "clean", className: "item_close" });
        }
        return (react_1.default.createElement("div", { className: classnames_1.default("item", item.error ? "error" : null), key: "notification-item-" + item.id },
            react_1.default.createElement("div", { className: "item_content" }, item.children),
            btn));
    });
    return react_1.default.createElement("div", { className: classnames_1.default("emankit__notification_bar", errorBar ? "error" : null, className) }, itemData);
};
exports.default = notificationBar;
//# sourceMappingURL=index.js.map